export default __webpack_public_path__ + "static/camera-b30b30d629e4cff6a51e2743142ac36f.svg";